import React from "react";
import { Modal } from "react-bootstrap";
import CreateAndEditPollForm from "./CreateAndEditPollForm";

const EditPollModal = ({ show, handleClose, selectedPoll }) => {
  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Edit Poll</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <CreateAndEditPollForm selectedPoll={selectedPoll} />
      </Modal.Body>
    </Modal>
  );
};

export default EditPollModal;
